import script from "./ColivingAdvancedSearch.vue?vue&type=script&setup=true&lang=js"
export * from "./ColivingAdvancedSearch.vue?vue&type=script&setup=true&lang=js"

import "./ColivingAdvancedSearch.vue?vue&type=style&index=0&id=5fabd06d&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-5fabd06d"]])

export default __exports__